export default "__VITE_ASSET__ChIlqDob__"